import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../../environment.js";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const SupportAdminDashboard = (history) => {
  return (
    <div class="container-fluid">
      <NavbarNew />
      <div>Hello</div>
    </div>
  );
};
export default SupportAdminDashboard;
